/** Tag wrapping the list of a message's attachments saved in the workspace. */
export const MESSAGE_ATTACHMENTS_TAG = 'message-attachments';

/** The workspace folder a conversation's attachments are saved in (no dot segment). */
export function conversationAttachmentsFolder(conversationId: string): string {
  return `attachments/${conversationId}`;
}

/**
 * The workspace path a message's file part was saved at, when it was (the CLI saves the
 * attachments of each message it sends an agent, see `saveMessageAttachments`).
 */
export function attachmentWorkspacePath(part: unknown): string | null {
  if (typeof part !== 'object' || part === null) return null;
  const metadata = (part as { providerMetadata?: unknown }).providerMetadata;
  if (typeof metadata !== 'object' || metadata === null) return null;
  const crowdex = (metadata as { crowdex?: unknown }).crowdex;
  if (typeof crowdex !== 'object' || crowdex === null) return null;
  const path = (crowdex as { workspacePath?: unknown }).workspacePath;
  return typeof path === 'string' && path.length > 0 ? path : null;
}

/** What the agent reads, after the message, about its attachments saved in the workspace. */
export function messageAttachmentsText(
  files: readonly { path: string; mediaType: string }[],
): string {
  return [
    `<${MESSAGE_ATTACHMENTS_TAG}>`,
    'The files attached to this message are saved in the workspace. Pass these paths to tools that read workspace files:',
    ...files.map((file) => `- ${file.path} (${file.mediaType})`),
    `</${MESSAGE_ATTACHMENTS_TAG}>`,
  ].join('\n');
}
